import {
  Col,
  Form,
  Image,
  Input,
  Layout,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Tooltip,
  Upload,
  Checkbox,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useMediaPredicate } from "react-media-hook";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import GoToTop from "../../components/GoToTop";
import Burger from "../../components/layouts/HomeLayout/Burger";
import { useScroll } from "../../utils/useScroll";
import Logo from "../../assets/img/logo-mobility.webp";
import Footer from "../../components/layouts/HomeLayout/Footer";
import { format } from "rut.js";
import "./index.less";
import { CaretDownOutlined, UploadOutlined } from "@ant-design/icons";
import {
  sendReportChannelPayload,
  sendReportChannelPayloadWithFile,
} from "../../requests/contact";
import ReCAPTCHA from "react-google-recaptcha";

function Complaints() {
  const [isHome, setIsHome] = useState(false);
  const [form] = Form.useForm();
  const [files, setFiles] = useState();
  const [loadingFile, setLoadingFile] = useState(false);
  const [complaint, setComplaint] = useState(null);
  const [complaintSubcategory, setComplaintSubcategory] = useState(null);
  const [anonymous, setAnonymous] = useState(false);
  const reRef = useRef();

  const fileTypes = [
    "image/jpeg",
    "image/png",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "audio/mpeg",
    "audio/wav",
    "video/mp4",
    "video/quicktime",
  ];

  const handleComplaintChange = (value) => {
    setComplaint(value);
    alert(value);
  };

  const validatePersonalFields = (_, value) => {
    if (complaint === "Ley Karin" && (!value || value.trim() === "")) {
      return Promise.reject(new Error("Este campo es obligatorio"));
    }
    return Promise.resolve();
  };

  const subCategories = {
    "Ley Karin": [
      "Seleccione",
      "Acoso laboral",
      "Acoso sexual",
      "Violencia en el trabajo ejercida por terceros ajenos a la relación laboral",
    ],
    "Ley 20.393": [
      "Seleccione",
      "Cohecho o soborno a funcionarios públicos nacionales o extranjeros",
      "Receptación",
      "Corrupción entre particulares",
      "Uso de información privilegiada",
      "Administración desleal",
      "Apropiación Indebida",
      "Adulteración a los estados financieros",
      "Falsificación de instrumento público o privado",
      "Otros Delitos Ley 20.393",
    ],
    "Ley 19.913": [
      "Seleccione",
      "Lavado de activos",
      "Financiamiento del terrorismo",
      "Operaciones Sospechosas",
    ],
    "Otras denuncias": ["Otras"],
  };

  const burguerData = [
    {
      title: "Sucursales",
      link: "/sucursales",
    },
    {
      title: "Nuestros servicios",
      link: "#servicios",
    },
    {
      title: "Quienes Somos",
      link: "#nosotros",
    },
    { title: "Beneficios", link: "#beneficios" },
    { title: "Publicaciones", link: "#publicaciones" },
  ];

  const biggerThan900 = useMediaPredicate("(min-width: 992px)");
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (window.location.pathname === "/avisos-legales") {
      setIsHome(false);
    } else {
      setIsHome(true);
    }
  }, [window.location.pathname]);

  const props = {
    name: "files",
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const { scrollDirection } = useScroll();

  const onFinish = async (values) => {
    if (files) {
      setLoadingFile(true);
    } else {
      setLoadingFile(false);
    }

    try {
      const token = await reRef.current.executeAsync();
      reRef.current.reset();
      values.rut = format(values.rut, { dots: false });
      values.phoneNumber = +values.phoneNumber;

      values.complaint = complaint;
      values.complaintSubcategory = complaintSubcategory;

      delete values.anonymous;
      delete values.complaintProof;

      let targetEmail = "";
      switch (complaint) {
        case "Ley Karin":
          targetEmail = "denunciaslaborales@gamaleasing.cl";
          break;
        case "Ley 19.913":
          targetEmail = "oficialdelcumplimiento@gamaleasing.cl";
          break;
        case "Ley 20.393":
          targetEmail = "denuncias@gamaleasing.cl";
          break;
        case "Otras denuncias":
          targetEmail = "denuncias@gamaleasing.cl";
          break;
        default:
          targetEmail = "denuncias@gamaleasing.cl";
          break;
      }

      const payload = { ...values, reCaptcha: token, targetEmail };

      const { data } = files
        ? await sendReportChannelPayloadWithFile(payload, files)
        : await sendReportChannelPayload(payload);

      if (data.success)
        return Modal.success({
          content: (
            <>
              <div>
                Muchas gracias, ha terminado de ingresar los datos de su caso.
                <br />
                GAMA garantiza que todas las denuncias que sean formalmente
                presentadas serán investigadas en forma seria y responsable,
                además de mantener la confidencialidad necesaria.
              </div>
            </>
          ),
          onOk() {
            window.location.replace("/");
          },
        });
      setFiles(null);
      setLoadingFile(false);
    } catch (error) {
      setLoadingFile(false);
      console.error(error);
      if (error?.status === 409) {
        return Modal.error({
          content: (
            <>
              <div>Archivo no valido</div>
              <div>Archivos permitidos: </div>
              <span>
                jpeg, png, pdf, msword, xml, powerpoint, mpeg, wav, mp4,
                quicktime.
              </span>
            </>
          ),
        });
      }
      if (error?.status === 403) {
        return Modal.error({
          content: "Ha superado la cantidad máxima de archivos (5)",
        });
      }
      if (error?.status === 413) {
        return Modal.error({
          content: "El peso del archivo supera máximo 10MB",
        });
      }
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      setFiles(null);
      return e;
    }

    const sum = e.fileList.reduce((acc, item) => acc + parseInt(item.size), 0);

    if (sum > 7000000) {
      e.fileList.pop();
      return Modal.error({
        content: `El peso total de todos los archivos supera el máximo de 10MB`,
      });
    }

    if (e.fileList.length === 1) setFiles(e.fileList[0].originFileObj);

    if (e.fileList.length > 5) {
      e.fileList.pop();
      return Modal.error({
        content: "Ha superado la cantidad máxima de archivos (5)",
      });
    }

    e.fileList.map((file) => {
      if (file.size > 10000000) {
        e.fileList.pop();
        return Modal.error({
          content: `El peso del archivo ${file?.name} supera el máximo de 10MB`,
        });
      } else {
        setFiles(e.fileList.map((file) => file.originFileObj));
      }
    });

    e.fileList.map((file) => {
      if (fileTypes?.includes(file?.type)) {
        setFiles(e.fileList.map((file) => file.originFileObj));
      } else {
        e.fileList.pop();
        return Modal.error({
          content: (
            <div>
              <div>El Archivo {file.name} no tiene un formato valido.</div>
              <div>Archivos permitidos: </div>
              <span>
                jpeg, png, pdf, msword, xml, powerpoint, mpeg, wav, mp4,
                quicktime.
              </span>
            </div>
          ),
        });
      }
    });

    return e?.fileList;
  };

  const styles = {
    active: {
      // visibility: "visible",
      transition: "all 0.2s ease-in-out",
    },
    hidden: {
      // visibility: "hidden",
      transition: "all 0.2s ease-in-out",
      transform: biggerThan900 && "translateY(-2.3rem)",
    },
  };

  const { TextArea } = Input;

  const { Option } = Select;

  return (
    <div className="required-none">
      <GoToTop />
      <Layout>
        <section
          className="home-banner-container"
          id="header"
          style={{
            height: `12vh`,
          }}
        >
          <Row className="header-contain">
            <Col
              id="navbar"
              style={
                scrollDirection === "down" || !scrollDirection
                  ? styles.active
                  : styles.hidden
              }
            >
              <nav className="home-nav-container">
                <ul>
                  <li>
                    <a
                      style={{
                        color:
                          window.location.pathname === "/mobility"
                            ? "#FF3200"
                            : "white",
                      }}
                      target="_blank"
                      href={"https://gamamobility.cl/"}
                      rel="noreferrer"
                    >
                      GAMA MOBILITY
                    </a>
                  </li>
                  <li>
                    <Link
                      style={{
                        color:
                          window.location.pathname === "" ? "#FF3200" : "white",
                      }}
                      to={"/"}
                    >
                      GAMA LEASING
                    </Link>
                  </li>

                  <li>
                    <a href={"https://www.gamarent.cl/"}>RENT A CAR</a>
                  </li>
                  <li>
                    <a href={"https://www.tripp.cl/"}>TRIPP</a>
                  </li>
                  <li>
                    <Link to={"/usados"}>GAMA USADOS</Link>
                  </li>
                </ul>
              </nav>
              <header>
                <div className="home-nav-items">
                  <div className="home-nav-logo">
                    <Link to={"/"}>
                      <Image preview={false} src={Logo} width={120} />
                    </Link>
                  </div>
                  <div className="group-nav-items">
                    <div
                      className="nav-container-buttons"
                      style={{
                        transition: "all ease-out 1s;",
                        opacity: `${visible ? "0" : "1"}`,
                        pointerEvents: `${visible ? "none" : "auto"}`,
                      }}
                    >
                      <Link to="/contacto-mobility">
                        <Button
                          onClick={() => {}}
                          className="gama-outline talk-button"
                        >
                          Conversemos
                        </Button>
                      </Link>
                    </div>
                    <div className="container-menu">
                      {biggerThan900 ? (
                        <div className="container-navlinks">
                          {!isHome ? (
                            <>
                              <a smooth href="/sucursales">
                                Sucursales
                              </a>
                              <a smooth href="#servicios">
                                Nuestros Servicios
                              </a>
                              <a smooth href="#nosotros">
                                Quienes Somos
                              </a>
                              <a smooth href="#beneficios">
                                Beneficios
                              </a>
                              <a smooth href="#publicaciones">
                                Publicaciones
                              </a>
                            </>
                          ) : (
                            <>
                              <Link to="/sucursales">Sucursales</Link>
                              <a smooth href="/mobility#servicios">
                                Nuestros Servicios
                              </a>
                              <a smooth href="/mobility#nosotros">
                                Quienes Somos
                              </a>
                              <a href="/mobility#beneficios">Beneficios</a>
                              <a href="/mobility#publicaciones">
                                Publicaciones
                              </a>
                            </>
                          )}
                        </div>
                      ) : (
                        <Burger
                          data={burguerData}
                          modal={visible}
                          onClose={() => {
                            setVisible(!visible);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </header>
            </Col>
          </Row>
        </section>
      </Layout>
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "70px",
          fontSize: "32px",
          fontWeight: "600",
        }}
      >
        <Col>CANAL DE DENUNCIAS</Col>
      </Row>
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Row
          style={{
            margin: "30px 15px",
            padding: "30px",
            width: "60%",
            fontSize: "14px",
            lineHeight: "30px",
            fontWeight: "300",
            fontFamily: "Montserrat",
            color: "#596b7f",
          }}
        >
          <Col>
            Nuestros canales son parte del sistema de gestión ética y compliance
            de Gama Mobility, orientado a promover el correcto accionar de todos
            nuestros directores, altos ejecutivos, miembros de la
            administración, accionistas, clientes, colaboradores, proveedores y
            prestadores de servicios transitorios, siguiendo los lineamientos,
            políticas y procedimientos establecidos en la Compañía. <br />
            <br />
            Nuestros canales de denuncia aseguran un análisis oportuno,
            independiente, confidencial y sin represalias a quienes presenten
            denuncias mediante los mismos, a través de la implementación de un
            proceso estructurado, cuyo cumplimiento es monitoreado.
          </Col>
        </Row>
      </Row>
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Row
            style={{
              border: "1px solid rgba(255, 50, 0, 0.1)",
              margin: biggerThan900
                ? "0px 30px 50px 60px"
                : "0px 15px 30px 15px",
              paddingTop: "50px",
              paddingLeft: "40px",
              borderRadius: "17px",
              width: "700px",
            }}
          >
            <Col>
              <Form
                name="complaints"
                initialValues={{ complaints: [[{}]] }}
                form={form}
                onFinish={onFinish}
                labelCol={{
                  span: 24,
                }}
                layout="horizontal"
              >
                <Row>
                  <Col sm={24} md={10} style={{ marginRight: "50px" }}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Este campo es obligatorio",
                        },
                      ]}
                      name="complaint"
                      label="Tipo Denuncia"
                      style={{ fontWeight: "bold", marginBottom: "40px" }}
                    >
                      <Select
                        onChange={(value) => {
                          setComplaint(value);
                          setComplaintSubcategory("");
                          setAnonymous(false);
                          form.setFieldsValue({ complaintSubcategory: "" });
                          form.setFieldsValue({ anonymous: false });
                          if (value === "Ley Karin") {
                            Modal.info({
                              title: "Atención",
                              content: "Debes completar tus datos personales",
                              okText: "Entendido",
                            });
                          } else {
                            // Limpiar errores de validación en campos personales
                            form.setFields([
                              { name: "rut", errors: [] },
                              { name: "name", errors: [] },
                              { name: "email", errors: [] },
                              { name: "phoneNumber", errors: [] },
                            ]);
                          }
                        }}
                        suffixIcon={<CaretDownOutlined />}
                      >
                        <Select.Option value="Ley Karin">
                          Ley Karin
                        </Select.Option>
                        <Select.Option value="Ley 20.393">
                          Ley 20.393
                        </Select.Option>
                        <Select.Option value="Ley 19.913">
                          Ley 19.913
                        </Select.Option>
                        <Select.Option value="Otras denuncias">
                          Otras denuncias
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col sm={24} md={10} style={{ marginRight: "50px" }}>
                    {complaint && (
                      <Form.Item
                        name="complaintSubcategory"
                        label="Subcategoría"
                        rules={[
                          {
                            required: true,
                            message: "Este campo es obligatorio",
                          },
                        ]}
                        style={{ fontWeight: "bold", marginBottom: "40px" }}
                      >
                        <Select
                          onChange={(value) => setComplaintSubcategory(value)}
                          suffixIcon={<CaretDownOutlined />}
                        >
                          <Select.Option value="">Seleccione</Select.Option>

                          {complaint &&
                            subCategories[complaint] &&
                            subCategories[complaint]
                              .filter((sub) => sub !== "Seleccione")
                              .map((sub, idx) => (
                                <Select.Option key={idx} value={sub}>
                                  {sub}
                                </Select.Option>
                              ))}
                        </Select>
                      </Form.Item>
                    )}
                  </Col>
                  <Col sm={24} md={10} style={{ marginRight: "50px" }}>
                    <Form.Item
                      rules={[
                        { validator: validatePersonalFields },
                        {
                          required: true,
                          message: "Este campo es obligatorio",
                        },
                        {
                          max: 20,
                          message: "Debe tener máximo 20 caracteres",
                        },
                        {
                          pattern: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s0-9]+$/,
                          message:
                            "La razón social no puede incluir caracteres especiales",
                        },
                      ]}
                      name="personalComplaint"
                      label="Tipo personal"
                      labelCol={{
                        span: 24,
                      }}
                      style={{
                        width: "100%",
                        fontWeight: "bold",
                        marginBottom: "40px",
                      }}
                    >
                      <Select suffixIcon={<CaretDownOutlined />}>
                        <Select.Option value="Interno">Interno</Select.Option>

                        <Select.Option value="Externo proveedor">
                          Externo proveedor
                        </Select.Option>
                        <Select.Option value="Externo Cliente">
                          Externo Cliente
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col sm={24} md={24} style={{ marginRight: "50px" }}>
                    {complaint !== "Ley Karin" && (
                      <Form.Item
                        name="anonymous"
                        valuePropName="checked"
                        label="Denuncia anónima"
                        style={{ fontWeight: "bold", marginBottom: "40px" }}
                      >
                        <Checkbox
                          onChange={(e) => setAnonymous(e.target.checked)}
                        >
                          Deseo que esta denuncia sea anónima, por lo que no
                          dejaré datos de contacto.
                        </Checkbox>
                      </Form.Item>
                    )}
                  </Col>
                </Row>

                {!anonymous && (
                  <>
                    <Row>
                      <Col sm={24} md={10} style={{ marginRight: "50px" }}>
                        <Form.Item
                          rules={[{ validator: validatePersonalFields }]}
                          name="rut"
                          normalize={(value) => format(value)}
                          label="Rut/Número documento"
                          style={{ fontWeight: "bold", marginBottom: "40px" }}
                        >
                          <Input style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                      <Col sm={24} md={10} style={{ marginRight: "30px" }}>
                        <Form.Item
                          rules={[
                            { validator: validatePersonalFields },
                            {
                              whitespace: true,
                            },
                            {
                              min: 2,
                              message: "Debe tener al menos 2 caracteres",
                            },
                            {
                              max: 50,
                              message: "Debe tener máximo 50 caracteres",
                            },
                            {
                              pattern: /^[A-Za-z\s.'Ññ]+$/,
                              message: "El nombre solo debe incluir letras.",
                            },
                          ]}
                          name="name"
                          label="Nombre Completo"
                          labelCol={{
                            span: 24,
                          }}
                          style={{
                            width: "100%",
                            fontWeight: "bold",
                            marginBottom: "40px",
                          }}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm={24} md={10} style={{ marginRight: "50px" }}>
                        <Form.Item
                          style={{
                            width: "100%",
                            fontWeight: "bold",
                            marginBottom: "40px",
                          }}
                          name="email"
                          label="Correo electrónico"
                          rules={[
                            { validator: validatePersonalFields },
                            {
                              type: "email",
                              message: "Por favor ingrese un correo válido",
                            },
                            {
                              max: 40,
                              message:
                                "No puede ingresar más de 40 caracteres en un correo",
                            },
                            {
                              whitespace: true,
                            },
                            {
                              pattern: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s0-9@.]+$/,
                              message: "No puede incluir caracteres especiales",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col sm={24} md={10} style={{ marginRight: "50px" }}>
                        <Form.Item
                          rules={[
                            { validator: validatePersonalFields },
                            {
                              pattern: /^[+]*\d{9}$/,
                              message:
                                "Ingrese un número válido, sin letras y de 9 dígitos.",
                            },
                          ]}
                          name="phoneNumber"
                          label="Teléfono Contacto"
                          labelCol={{
                            span: 24,
                          }}
                          style={{
                            width: "100%",
                            fontWeight: "bold",
                            marginBottom: "40px",
                          }}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}

                <Row>
                  <Col sm={24} md={10} style={{ marginRight: "50px" }}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Este campo es obligatorio",
                        },
                      ]}
                      name="complaintRealization"
                      label="¿Cómo se dió cuenta de esta infracción?"
                      style={{ fontWeight: "bold", marginBottom: "40px" }}
                    >
                      <Select suffixIcon={<CaretDownOutlined />}>
                        <Select.Option value=" Me sucedio">
                          Me sucedió
                        </Select.Option>
                        <Select.Option value="Lo observe">
                          Lo observé
                        </Select.Option>
                        <Select.Option value="Un compañero de trabajo me conto sobre el tema">
                          Un compañero de trabajo me contó sobre el tema
                        </Select.Option>
                        <Select.Option value=" Lo escuche">
                          Lo escuché
                        </Select.Option>
                        <Select.Option value="Alguien fuera de la empresa me lo conto">
                          Alguien fuera de la empresa me lo contó
                        </Select.Option>
                        <Select.Option value="Encontre accidentalmente un documento o archivo">
                          Encontré accidentalmente un documento o archivo
                        </Select.Option>
                        <Select.Option value="Otro">Otro</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col sm={24} md={10} style={{ marginRight: "50px" }}>
                    <Form.Item
                      name="others"
                      label="Otros asuntos"
                      style={{ fontWeight: "bold", marginBottom: "40px" }}
                    >
                      <Select style={{ marginRight: "50px" }}>
                        <Select.Option value=" Me sucedio">
                          Me sucedió
                        </Select.Option>
                        <Select.Option value="Lo observe">
                          Lo observé
                        </Select.Option>
                        <Select.Option value="Un compañero de trabajo me conto sobre el tema">
                          Un compañero de trabajo me contó sobre el tema
                        </Select.Option>
                        <Select.Option value=" Lo escuche">
                          Lo escuché
                        </Select.Option>
                        <Select.Option value="Alguien fuera de la empresa me lo conto">
                          Alguien fuera de la empresa me lo contó
                        </Select.Option>
                        <Select.Option value="Encontre accidentalmente un documento o archivo">
                          Encontré accidentalmente un documento o archivo
                        </Select.Option>
                        <Select.Option value="Otro">Otro</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col sm={24} md={10} style={{ marginRight: "50px" }}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Este campo es obligatorio",
                        },
                        {
                          max: 9999,
                          message: "Debe tener máximo 9999 caracteres",
                        },
                        {
                          pattern: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s0-9]+$/,
                          message: "No puede incluir caracteres especiales",
                        },
                      ]}
                      name="complaintDetails"
                      label="

                      Detalles de la denuncia *"
                      labelCol={{
                        span: 24,
                      }}
                      style={{
                        width: "100%",
                        fontWeight: "bold",
                        marginBottom: "40px",
                      }}
                    >
                      <TextArea />
                    </Form.Item>
                  </Col>
                  <Col sm={24} md={10} style={{ marginRight: "50px" }}>
                    <Form.Item
                      name="complaintProof"
                      label="Aporte las evidencias en su poder:"
                      getValueFromEvent={normFile}
                      labelCol={{
                        span: 24,
                      }}
                      style={{
                        width: "100%",
                        fontWeight: "bold",
                        marginBottom: "40px",
                      }}
                    >
                      <Upload
                        beforeUpload={() => false}
                        style={{ height: "50px!important" }}
                        {...props}
                      >
                        <Button
                          style={{
                            width: "100%",
                            backgroundColor: "#596b7f",
                            borderColor: "#596b7f",
                          }}
                          icon={<UploadOutlined />}
                        >
                          Subir Documentos
                        </Button>
                        {loadingFile && (
                          <div style={{ display: "flex", marginTop: "15px" }}>
                            <span>Cargando documentos, por favor espere.</span>
                            <Spin />
                          </div>
                        )}
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>

                <Row
                  align={biggerThan900 ? "middle" : ""}
                  justify={biggerThan900 ? "center" : ""}
                  style={{ marginTop: "10px", marginBottom: "30px" }}
                >
                  <Button
                    style={{
                      width: "40%",
                      backgroundColor: "#00c35a",
                      borderColor: "#00c35a",
                    }}
                    type="primary"
                    onClick={() => form.submit()}
                  >
                    Enviar formulario
                  </Button>
                </Row>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
                  ref={reRef}
                  size="invisible"
                />
              </Form>
            </Col>
          </Row>
        </Row>
      </Row>
      <Footer />
    </div>
  );
}

export default Complaints;
